import { render, staticRenderFns } from "./OrdinaryRobotActive.vue?vue&type=template&id=d015c78a&scoped=true&"
import script from "./OrdinaryRobotActive.vue?vue&type=script&lang=js&"
export * from "./OrdinaryRobotActive.vue?vue&type=script&lang=js&"
import style0 from "./OrdinaryRobotActive.vue?vue&type=style&index=0&id=d015c78a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d015c78a",
  null
  
)

export default component.exports